import { render, staticRenderFns } from "./PriorityTaskModal.vue?vue&type=template&id=51ab0cca&scoped=true"
import script from "./PriorityTaskModal.vue?vue&type=script&lang=js"
export * from "./PriorityTaskModal.vue?vue&type=script&lang=js"
import style0 from "./PriorityTaskModal.vue?vue&type=style&index=0&id=51ab0cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab0cca",
  null
  
)

export default component.exports